import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconUserSvg } from './IconUserSvg';

export const IconUser: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconUserSvg} {...iconProps} />;
};
